"use strict";

exports.__esModule = true;
exports.withTranslator = withTranslator;
var _react = _interopRequireDefault(require("react"));
var _Translator = require("./Translator");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * HOC for translations.
 * Turns a component into one which automatically
 * receives a `translator` prop.
 */
function withTranslator(Component) {
  return function (props) {
    return /*#__PURE__*/_react["default"].createElement(_Translator.Translator, null, function (value) {
      return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, props, {
        translator: value
      }));
    });
  };
}